{
  "GENERAL": {
    "CLOSE": "Chiudi",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Cerca",
      "EMPTY_STATE": "Nessun risultato trovato"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Almeno {count} richiesti"
  }
}
